import React, { useState } from 'react';

const WalkthroughModal = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    businessName: '',
    websiteUrl: '',
    email: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Simulate submission - you can integrate with your backend here
    setTimeout(() => {
      console.log('Walkthrough request:', formData);
      setIsSubmitting(false);
      setSubmitSuccess(true);
      
      // Reset and close after 2 seconds
      setTimeout(() => {
        setSubmitSuccess(false);
        setFormData({ businessName: '', websiteUrl: '', email: '' });
        onClose();
      }, 2000);
    }, 1000);
  };

  if (!isOpen) return null;

  return (
    <div className="walkthrough-modal-overlay" onClick={onClose}>
      <div className="walkthrough-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="walkthrough-modal-close" onClick={onClose}>×</button>
        
        <div className="walkthrough-modal-header">
          <h2>Get a Personalized Walkthrough</h2>
          <p>Tell us about your business and we'll guide you through our platform</p>
        </div>

        {submitSuccess ? (
          <div className="walkthrough-success-message">
            <div className="success-icon">✓</div>
            <h3>Request Submitted!</h3>
            <p>We'll be in touch soon to schedule your walkthrough.</p>
          </div>
        ) : (
          <form className="walkthrough-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="businessName">Business Name *</label>
              <input
                type="text"
                id="businessName"
                name="businessName"
                value={formData.businessName}
                onChange={handleChange}
                placeholder="Enter your business name"
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="websiteUrl">Website URL</label>
              <input
                type="url"
                id="websiteUrl"
                name="websiteUrl"
                value={formData.websiteUrl}
                onChange={handleChange}
                placeholder="https://www.yourbusiness.com (optional)"
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">Email Address *</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="your@email.com"
                required
              />
            </div>

            <button 
              type="submit" 
              className="walkthrough-submit-btn"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Submitting...' : 'Request Walkthrough'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default WalkthroughModal;

